import { render, staticRenderFns } from "./data.vue?vue&type=template&id=1eaacd6a&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"
import style0 from "./data.vue?vue&type=style&index=0&id=1eaacd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaacd6a",
  null
  
)

export default component.exports